import { Route } from '@angular/router';

export const shanghaiStatisticsRoutes: Route[] = [
    {
        path: 'shanghai/details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/shanghai-statistics-details/shanghai-statistics-details.component').then(
                (c) => c.ShanghaiStatisticsDetailsComponent
            ),
    },
    {
        path: 'shanghai/games/tab/:tab',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/shanghai-statistics-games/shanghai-statistics-games.component').then(
                (c) => c.ShanghaiStatisticsGamesComponent
            ),
    },
    {
        path: 'shanghai/games/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/shanghai-statistics-games-details/shanghai-statistics-games-details.component').then(
                (c) => c.ShanghaiStatisticsGamesDetailsComponent
            ),
    },
];
